export var BenefitTypeEnum;
(function (BenefitTypeEnum) {
    BenefitTypeEnum[BenefitTypeEnum["Tickets"] = 0] = "Tickets";
    BenefitTypeEnum[BenefitTypeEnum["Vouchers"] = 1] = "Vouchers";
    BenefitTypeEnum[BenefitTypeEnum["Others"] = 2] = "Others";
})(BenefitTypeEnum || (BenefitTypeEnum = {}));
